<template>
  <div>
    <div class="conclusion-mobile__header--wrapper">
      <h2 class="conclusion-mobile__header--title">
        Check-in realizado. Siga as orientações abaixo no dia do seu atendimento
      </h2>
    </div>

    <div class="conclusion-mobile__card--wrapper">
      <p class="conclusion-mobile__card--header">Orientações</p>
      <div class="conclusion-mobile__card--content">
        <p class="conclusion-mobile__card--title">Documentos necessários</p>
        <ul>
          <li class="conclusion-mobile__card--text">Documento original com foto</li>
          <li class="conclusion-mobile__card--text">
            Pedido médico impresso (mesmo para pedido médicos digitais)
          </li>
          <li class="conclusion-mobile__card--text" v-if="isHealthInsurancePayment">Carteirinha do convênio (se houver)</li>
        </ul>
      </div>
      <div class="conclusion-mobile__card--content">
        <p class="conclusion-mobile__card--title">Preparo dos exames</p>
        <p class="conclusion-mobile__card--text">
          Confira seu e-mail para mais informações sobre o preparo dos seus exames.
        </p>
      </div>
      <div class="conclusion-mobile__card--content" v-if="isPrivatePayment">
        <p class="conclusion-mobile__card--title">Pagamento</p>
        <p class="conclusion-mobile__card--text">
          O pagamento particular é feito diretamento para o profissional que irá realizar o
          atendimento.
        </p>
      </div>
    </div>

    <div class="conclusion-mobile__card--wrapper">
      <p class="conclusion-mobile__card--header">Seu atendimento domiciliar</p>
      <div class="conclusion-mobile__card--content">
        <p class="conclusion-mobile__card--title">Data e hora agendada</p>
        <p class="conclusion-mobile__card--text">{{admissionDateFormatted()}}</p>
      </div>
      <div class="conclusion-mobile__card--content">
        <p class="conclusion-mobile__card--title">Chegada do profissional</p>
        <p class="conclusion-mobile__card--text">
          Chegada será entre 20 minutos antes ou após o horário agendado. Você receberá por whatsapp
          ou sms um link para acompanhar a localização do profissional.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { PaymentTypeClient } from '@/utils/enums/paymentMagicNumberEnum';
import { admissionProcessFinishedMixin } from '@/utils/mixins';

export default {
  name: 'CheckinConclusionMobile',
  mixins: [admissionProcessFinishedMixin],

  data() {
    return {
      isPrivatePayment: false,
      isHealthInsurancePayment: false
    };
  },

  computed: {
    ...mapState({
      admissionDate: ({ currentAdmission }) => currentAdmission.data.admissionDate,
      currentAdmissionPayment: ({ currentAdmission }) => currentAdmission.data.payments[0],
    }),

    ...mapGetters({
      isMobileService: 'isMobileService',
    }),
  },
  methods: {
    verifyPayment() {
      this.isPrivatePayment = this.currentAdmissionPayment.clientId === PaymentTypeClient.PRIVATE;
      this.isHealthInsurancePayment = !this.isPrivatePayment;
    },
    admissionDateFormatted() {
      const day = moment(this.admissionDate).calendar({
        sameDay: 'DD/MM/YYYY ([Hoje])',
        nextDay: 'DD/MM/YYYY ([Amanhã])',
        lastWeek: 'DD/MM/YYYY',
        nextWeek: 'DD/MM/YYYY',
        sameElse: 'DD/MM/YYYY'
      });
      return `${day} às ${moment(this.admissionDate).format('kk:mm')}`;
    },
  },
  async created() {
    await this.admissionProcessFinished();

    this.verifyPayment();
  }
};
</script>

<style lang="scss" scoped>
.conclusion-mobile {
  &__header {
    &--wrapper {
      background-color: #002fdb;
      padding: $gap-cozy $gap-default;
      border-radius: $border-radius;
      position: relative;
    }

    &--title {
      color: #fefefe;
      font-size: 24px;
      line-height: 30px;
      font-weight: 700;
    }
  }

  &__card {
    &--wrapper {
      background-color: #fefefe;
      padding: 24px 24px 8px;
      gap: 24px;
      border: 1px solid var(--color-neutral-20);
      border-radius: 8px;
      margin-top: 24px;
    }

    &--header {
      font-weight: var(--font-weight-medium);
      font-size: var(--font-size-3);
      line-height: 24px;
      color: var(--color-fill-grey-10);
      text-align: left;
      padding-bottom: 16px;
    }

    &--content {
      padding-bottom: 16px;
    }

    &--title {
      font-weight: var(--font-weight-extra-bold);
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      color: #666666;
      text-align: left;
      padding-left: 8px;
    }

    &--text {
      text-align: left;
      padding-left: 8px;
      font-size: var(--font-size-2);
      line-height: 24px;
    }
  }
}
li{
  margin-left: 28px;
list-style: initial;
}
</style>

<style lang="scss">
.container {
  background-color: #f5f5f5;
  padding-top: $gap-default;
  padding-bottom: $gap-default;
  height: max-content;
}
</style>
